/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoGlassWineIcon20Solid = forwardRef('FoodDrinkAlcoGlassWineIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 3.958C3 2.877 3.877 2 4.958 2h10.084C16.123 2 17 2.877 17 3.958V6.75a7.001 7.001 0 0 1-6 6.93V17h3.25a1 1 0 1 1 0 2h-8.5a1 1 0 1 1 0-2H9v-3.32a7.001 7.001 0 0 1-6-6.93V3.958Zm2 .292A.25.25 0 0 1 5.25 4h9.5a.25.25 0 0 1 .25.25V6H5V4.25Z" })));
});
